import axios from "axios";

const API = axios.create({
    baseURL: 'https://aisafetygenie.com/admin/api',
});

export default API;